export default function insertIds(state = [], { offset, ids }) {
    const stateCopy = [...state];

    for (let i = 0; i < ids.length; i++) {
        stateCopy[i + offset] = ids[i];
    }

    return stateCopy;
}
